var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12V16M24 16V20M24 16H28M24 16H20M17.3333 9.33333C17.3333 10.7478 16.7714 12.1044 15.7712 13.1046C14.771 14.1048 13.4145 14.6667 12 14.6667C10.5855 14.6667 9.22896 14.1048 8.22876 13.1046C7.22857 12.1044 6.66667 10.7478 6.66667 9.33333C6.66667 7.91885 7.22857 6.56229 8.22876 5.5621C9.22896 4.5619 10.5855 4 12 4C13.4145 4 14.771 4.5619 15.7712 5.5621C16.7714 6.56229 17.3333 7.91885 17.3333 9.33333V9.33333ZM4 26.6667C4 24.5449 4.84286 22.5101 6.34315 21.0098C7.84344 19.5095 9.87827 18.6667 12 18.6667C14.1217 18.6667 16.1566 19.5095 17.6569 21.0098C19.1571 22.5101 20 24.5449 20 26.6667V28H4V26.6667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-user.541620b7adaf56a091c0fb153a679e78.svg";